import { DigitalChannelStatus } from '@nice-ccf/core-sdk';
import { createSlice, createSelector } from '@reduxjs/toolkit';
import { DigitalChannelMessage } from './ccf-interaction-body/ccf-digital-interaction-module-type';
export const UNIFIED_INTERACTION_KEY = 'interactionState';

interface Interactiondetails {
  interactionID: string;
  allTabs: interactionTab[];
  noOfTabs: number;
  activeTab: string;
}
export interface interactionTab {
  tabName: string;
  isDispositionCompleted: boolean;
}
interface InteractionTabData {
  [interactionID: string]: {
    [tabName: string]: {
      agentReply: [];
    };
  };
}
export interface historyEmailTemplate {
  isEmailInteractionSelected: boolean,
  correspondingDate: string,
}

export interface interactionMsgCount {
  interactionID: string;
  userChatMsgCount: number;
}
export interface interactionType {
  interactionSpaceData: Interactiondetails[];
  activeInteraction: Interactiondetails;
  interactionTabData: InteractionTabData;
  previewImgPathData: any[];
  interactionMsgCount: interactionMsgCount[];
  isCoBrowsingSessionClosed: boolean;
  emailInteractionFromHistory: historyEmailTemplate;
}
export const initialInteractionState: interactionType = {
  interactionSpaceData: [],
  activeInteraction: {
    interactionID: '',
    allTabs: [],
    noOfTabs: 0,
    activeTab: '',
  },
  interactionTabData: {},
  previewImgPathData: [],
  interactionMsgCount: [],
  isCoBrowsingSessionClosed: false,
  emailInteractionFromHistory: {
    isEmailInteractionSelected: false,
    correspondingDate: 'Mon, Apr 10 2023'
  },
};

export const interactionSlice = createSlice({
  name: UNIFIED_INTERACTION_KEY,
  initialState: initialInteractionState,
  reducers: {
    /**
     *
     * @param state -interactionType
     * @param action - any
     * @returns interaction header TaB
     * @example setInteractionHeaderTabs(state, action)
     */
    setInteractionHeaderTabs(state, action) {
      const newState = state;
      const filteredInteraction = newState.interactionSpaceData.filter(
        (x) => x.interactionID === action.payload.id
      );
      if (filteredInteraction.length === 1) {
        if (action.payload.contactStatus !== DigitalChannelStatus.NEW) {
          // eslint-disable-next-line array-callback-return
          filteredInteraction.map((item) => {
            if (!item.allTabs.includes(action.payload.contactType)) {
              // Check to add data only if tab already doesnt exist
              item.interactionID = action.payload.id;
              item.allTabs = item.allTabs.concat({
                tabName: action.payload.contactType,
                isDispositionCompleted: false,
              });
              item.noOfTabs++;
              item.activeTab = action.payload.contactType;
              newState.activeInteraction = item;
            }
          });
        } else {
          newState.activeInteraction = filteredInteraction[0];
        }
      } else {
        const obj = {
          interactionID: action.payload.id,
          allTabs: [
            {
              tabName: action.payload.contactType,
              isDispositionCompleted: false,
            },
          ],
          noOfTabs: 1,
          activeTab: action.payload.contactType,
        };
        newState.interactionSpaceData.push(obj);
        newState.activeInteraction = obj;
      }
      return newState;
    },

    /**
     *
     * @param state -interactionType
     * @param action - any
     * @returns
     * @example setInteractionForActiveContact(state, action)
     */
    setInteractionForActiveContact(state, action) {
      const newState = state;
      const filteredInteraction = newState.interactionSpaceData.filter(
        (x) => x.interactionID === action.payload.id
      );
      newState.activeInteraction = filteredInteraction[0];
      return newState;
    },

    /**
     *
     * @param state -interactionType
     * @param action - any
     * @returns
     * @example - setInteractionHeaderTabActive(state, action)
     */
    setInteractionHeaderTabActive(state, action) {
      const newState = state;
      newState.interactionSpaceData.forEach((item) => {
        if (item.interactionID === action.payload.id) {
          item.activeTab = action.payload.tab;
          newState.activeInteraction = item;
        }
      });
      return newState;
    },

    /**
     *
     * @param state -interactionType
     * @param action - any
     * @returns
     * @example - setEmailInteractionDates(state, action)
     */
    setEmailInteractionDates(state, action) {
      return {
        ...state,
        emailInteractionFromHistory: action.payload,
      };
    },

    /**
     *
     * @param state -interactionType
     * @param action - any
     * @returns
     * @example setInteractionForActiveContact(state, action)
     */
    setPreviewImgPathData(state, action) {
      return {
        ...state,
        previewImgPathData: action.payload,
      };
    },
    /**
     *
     * @param state -interactionType
     * @param action - any
     * @returns
     * @example setCoBrowsingSessionClosed(state, action)
     */
    setCoBrowsingSessionClosed(state, action) {
      return {
        ...state,
        isCoBrowsingSessionClosed: action.payload,
      };
    },
    setInteractionMsgCount: (state, action) => {
      return {
        ...state,
        interactionMsgCount: action.payload,
      };
    },
    setDispositionForTab: (state, action) => {
      const newState = state;
      newState.activeInteraction?.allTabs.forEach((item) => {
        if (item.tabName === action.payload.tabName) {
          item.isDispositionCompleted = true;
        }
      });
      newState.interactionSpaceData.forEach((item) => {
        if (item.interactionID === newState.activeInteraction?.interactionID) {
          item.allTabs.forEach((tab) => {
            if (tab.tabName === action.payload.tabName) {
              tab.isDispositionCompleted = true;
            }
          });
        }
      });
      return newState;
    },
    /**
     *
     * @param state -interactionType
     * @param action - any
     * @returns
     * @example - completeInteractionForContact(state, action)
     */
    completeInteractionForContact(state, action) {
      return {
        ...state,
        interactionSpaceData: state.interactionSpaceData.filter(
          (interaction) =>
            interaction.interactionID !== action.payload.interactionID
        ),
        activeInteraction: {
          interactionID: '',
          allTabs: [],
          noOfTabs: 0,
          activeTab: '',
        },
      };
    },
    setInteractionTabData: (state, action) => {
      return {
        ...state,
        interactionTabData: { ...state.interactionTabData, ...action.payload },
      };
    },
    updateTwitterAgentReply: (state, action) => {
      const { interactionID, tabName, replyMessage, deleteTweetId } =
        action.payload;
      const agentReply = deleteTweetId
        ? state.interactionTabData[interactionID][tabName].agentReply.filter(
            (msg: DigitalChannelMessage) => msg.messageId !== deleteTweetId
          )
        : [
            ...state.interactionTabData[interactionID][tabName].agentReply,
            replyMessage,
          ];
      return {
        ...state,
        interactionTabData: {
          ...state.interactionTabData,
          [interactionID]: {
            ...state.interactionTabData[interactionID],
            [tabName]: {
              ...state.interactionTabData[interactionID][tabName],
              agentReply,
            },
          },
        },
      };
    },
  },
});

export const interactionReducer = interactionSlice.reducer;
export const interactionSliceActions = interactionSlice.actions;
export default interactionSlice.reducer;

/**
 *
 * @param rootState - interactionType
 * @returns - initial state of interactions
 * @example const getIntState = getIntState(state)
 */
const getIntState = (rootState: { interactionState: interactionType }) => {
  return rootState[UNIFIED_INTERACTION_KEY];
};

export const interactionSpaceData = createSelector(
  getIntState,
  (state) => state.interactionSpaceData
);
export const activeInteraction = createSelector(
  getIntState,
  (state) => state.activeInteraction
);
export const getInteractionMsgCount = createSelector(
  getIntState,
  (state) => state.interactionMsgCount
);

export const getDispositionForActiveTab = createSelector(getIntState, (state) =>
  state.activeInteraction?.allTabs.find(
    (x) =>
      x.tabName === state.activeInteraction.activeTab &&
      x.isDispositionCompleted
  )
);

export const getInteractionTabData = createSelector(
  getIntState,
  (state) => state.interactionTabData
);

/**
 * Function to get interaction tab data by id
 * @param input - string
 * @example
 * @returns
 */
export const getInteractionTabDataByID = (input: string) =>
  createSelector(getIntState, (state) => state.interactionTabData[input]);

export const getPreviewImgPathData = createSelector(
  getIntState,
  (state) => state.previewImgPathData
);

export const getCoBrowsingSessionClosed = createSelector(
  getIntState,
  (state) => state.isCoBrowsingSessionClosed
);
export const getEmailHistoryDetails = createSelector(
  getIntState,
  (state) => state.emailInteractionFromHistory
);
